import request from "@/router/axios";

export const getList = (data) => {
  return request({
    url: '/api/produce/out-in-stock-record/weigh-bill/out/page',
    method: 'post',
    data
  })
}

export const exportPdf = (data) => {
  return request({
    url: '/api/produce/out-in-stock-record/weigh-bill/out/export/pdf',
    method: 'post',
    data,
    responseType: 'blob'
  })
}
